<template>
  <OmtStickedModal
    v-if="isOpen"
    @close="$emit('close')"
  >
    <CBox
      :pt="['8px', '69px']"
      mb="42px"
      data-cy="sent-pendency"
    >
      <OmtIcons
        name="check-circle"
        size="2x"
        mb="32px"
        color="success"
      />
      <OmtTypography
        as="h1-large"
        mb="32px"
      >
        Solicitação enviada <br />
        com sucesso!
      </OmtTypography>
      <CFlex
        align="center"
        mb="32px"
      >
        <OmtIcons
          name="square-poll-horizontal"
          mr="12px"
        />
        <OmtTypography as="h2-bold"> Protocolo: {{ protocol }} </OmtTypography>
      </CFlex>

      <CBox
        bg="var(--colors-light-primary-light-gray)"
        p="10px 16px 16px 16px"
      >
        <CFlex flex-direction="column">
          <CFlex>
            <OmtIcons
              name="bell-on"
              mr="16px"
            />
            <OmtTypography
              v-if="isSkinive"
              as="h2-bold"
            >
              O resultado da sua análise será disponibilizado em breve.
            </OmtTypography>
            <OmtTypography
              v-else-if="isOuvidoria || isHealthPrograms"
              as="h2-bold"
            >
              A análise da sua solicitação será feita em até 5 dias úteis.
            </OmtTypography>
            <OmtTypography
              v-else-if="!outros"
              as="h2-bold"
            >
              A análise será feita em até {{ deadlineDays }} dias úteis.
            </OmtTypography>
            <OmtTypography
              v-else
              as="h2-bold"
            >
              A análise da solicitação será feita em até {{ deadlineDays }} dias úteis.
            </OmtTypography>
          </CFlex>
          <OmtTypography
            v-if="isOuvidoria"
            as="p1"
            mt="16px !important"
          >
            Você pode acompanhar o status desta solicitação pelo app, na opção "Ouvidoria".
          </OmtTypography>
          <OmtTypography
            v-else
            as="p1"
            mt="16px !important"
          >
            Você pode acompanhar o status dessa solicitação pela área {{ requestAreaLabel }}.
          </OmtTypography>
        </CFlex>
      </CBox>
    </CBox>
    <OmtTypography
      as="p1"
      mb="16px"
    >
      <omt-bold>Como você avalia sua experiência com esse serviço pelo APP Minha Omint?</omt-bold>
    </OmtTypography>

    <CFlex
      justify="space-between"
      mb="8px"
    >
      <OmtButton
        v-for="rate in 5"
        :key="rate"
        :variant="rate === selectedRate ? 'solid' : 'outline'"
        width="48px"
        height="50px"
        border="0.5px solid var(--colors-light-secondary-divider)"
        borderRadius="50%"
        data-cy="rate-buttons"
        @click="selectRate(rate)"
      >
        <OmtTypography
          as="p1"
          :color="rate === selectedRate ? 'white' : 'inherit'"
        >
          {{ rate }}
        </OmtTypography>
      </OmtButton>
    </CFlex>

    <CFlex
      justify="space-between"
      mb="22px"
    >
      <OmtTypography as="p2"> Muito difícil </OmtTypography>
      <OmtTypography as="p2"> Muito fácil </OmtTypography>
    </CFlex>

    <OmtRow v-if="selectedRate && selectedRate <= 2">
      <CFlex
        flexDirection="column"
        alignItems="flex-end"
      >
        <OmtTextarea
          class="input-observation"
          height="109px"
          padding="12px"
          placeholder="Inclua informações ou detalhes que podem complementar sua avaliação."
          :initialValue="observation"
          @change="handleChange"
        />
        <OmtTypography
          as="p2"
          color="var(--colors-light-primary-gray2)"
        >
          {{ observation.length }}/350
        </OmtTypography>
      </CFlex>
    </OmtRow>

    <template #footer>
      <OmtButton
        w="100%"
        :disabled="selectedRate === null"
        @click="submit"
      >
        Concluir
      </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean
    },
    daysAnalizy: {
      type: Number
    },
    protocol: {
      type: String
    },
    isOutros: {
      type: Boolean,
      default: false
    },
    isOuvidoria: {
      type: Boolean,
      default: false
    },
    flowType: {
      type: String,
      default: "default"
    }
  },
  data() {
    return {
      selectedRate: null,
      observation: "",
      outros: false
    };
  },
  computed: {
    isHealthPrograms() {
      return this.flowType === "healthPrograms";
    },
    isSkinive() {
      return this.flowType === "skinive";
    },
    requestAreaLabel() {
      if (this.isSkinive) return "Análise de Pele";
      return this.isHealthPrograms ? "Programas de Saúde" : "Minhas Solicitações";
    },
    deadlineDays() {
      return this.isHealthPrograms ? 5 : this.daysAnalizy;
    }
  },
  mounted() {
    this.outros = this.isOutros;
  },
  methods: {
    submit() {
      this.$emit("save", { rating: this.selectedRate, obs: this.observation });
    },
    selectRate(rate) {
      this.selectedRate = rate;
    },
    handleChange(text) {
      this.observation = text;
    }
  }
};
</script>
